import { ChatConfig } from '@apparel/core/chat/ChatConfig';
import { ChatEvents } from '@apparel/core/chat/ChatEvents';
import { ChatService } from '@apparel/core/chat/ChatService';
import { Log } from '@apparel/core/log';
import { ChatMessage } from '@apparel/core/models/ChatMessage';
import { useEffect, useMemo } from 'react';
import { useService } from '../../hooks/useService';
import { useChatContext } from './ChatContext';

let eventsAdded = false;

export const useChatSocket = (chatConfig?: ChatConfig) => {
    const chat = useService(ChatService);
    const chatState = useChatContext();
    const logger = useMemo(() => Log.channel('useChatSocket'), []);

    useEffect(() => {
        chat.configure(chatConfig);
    }, [chatConfig]);

    useEffect(() => {
        if (!eventsAdded) {
            logger.debug('Setup', chat.config);
            chat.connect();

            const connectOff = chat.on(ChatEvents.CONNECT, () => {
                chatState.dispatch('setConnected', true);
            });

            const disconnectOff = chat.on(ChatEvents.DISCONNECT, (event) => {
                if (event.wasClean) {
                    chatState.dispatch('setConnected', false);
                }
            });

            const newMessageOff = chat.on(ChatEvents.NEW_MESSAGE, (message: ChatMessage) => {
                chatState.dispatch('addNewMessage', message);
                chatState.dispatch('addUnreadForRoom', message.room_id);
            });

            const userTypingOff = chat.on(ChatEvents.TYPING_MESSAGE, (data: any) => {
                chatState.dispatch('senderTyping', data);
            });

            const updatedMessageOff = chat.on(ChatEvents.UPDATED_MESSAGE, (message: ChatMessage) => {
                chatState.dispatch('updateMessage', message);
            });

            eventsAdded = true;
            return () => {
                logger.debug('Clean events');
                connectOff();
                newMessageOff();
                userTypingOff();
                disconnectOff();
                updatedMessageOff();
                chat.close();
                eventsAdded = false;
            };
        }

        return () => {
            eventsAdded = false;
        };
    }, []);
};
